<template>
<div class="hris-page">
  <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">System Settings</span>
      <h1 class="hris-page-title">Employment Status Settings</h1>
      <p class="hris-page-subtitle">Manage the employment status types used across the organization.</p>
    </div>

    <q-form ref="vForm" @submit="onSubmit">
      <div class="row q-col-gutter-md">
        <div class="col-12 col-md-4">
          <div class="hris-form-section">
            <h3 class="hris-form-section-title">Add Employment Status</h3>
            <div class="hris-form-field q-mb-md">
              <q-input v-model="empStatus" label="Employment Status" outlined dense color="green" :rules="[formRules.required]" class="caps"></q-input>
            </div>
            <div class="q-gutter-sm q-mb-md">
              <q-radio keep-color color="green" v-model="is_active" val="Y" label="Active" :rules="[formRules.required]"></q-radio>
              <q-radio keep-color color="green" v-model="is_active" val="N" label="In-active" :rules="[formRules.required]"></q-radio>
            </div>
            <div class="hris-form-actions" style="padding-top: 0;">
              <q-btn unelevated class="hris-q-primary full-width" type="submit" label="Save"></q-btn>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-8">
          <div class="hris-panel">
            <h3 class="hris-panel-title">Employment Status List</h3>
            <q-table
              flat
              :data="data"
              :columns="columns"
              row-key="id"
              :pagination.sync="pagination"
            >
              <template v-slot:body="props">
                <q-tr :props="props" @click="selectedRow(props)" style="cursor: pointer;">
                  <q-td key="id" :props="props">{{ props.row.counter }}</q-td>
                  <q-td key="name" :props="props">{{ props.row.name }}</q-td>
                  <q-td key="is_active" :props="props">
                    <span class="hris-badge" :class="props.row.is_active == 'Y' ? 'hris-badge-success' : 'hris-badge-danger'">
                      {{ props.row.is_active == 'Y' ? 'Active' : 'Inactive' }}
                    </span>
                  </q-td>
                  <q-td key="action" :props="props">
                    <q-btn flat round dense class="hris-q-ghost" @click="removeRow(props)">
                      <i class="fas fa-trash"></i>
                      <q-tooltip>Remove</q-tooltip>
                    </q-btn>
                  </q-td>
                </q-tr>
              </template>
              <template v-slot:no-data="">
                <div class="hris-empty full-width">No results found.</div>
              </template>
            </q-table>
          </div>
        </div>
      </div>
    </q-form>

    <q-dialog v-model="spinner" persistent>
      <div class="hris-loading" style="background: var(--hris-surface); border-radius: var(--hris-radius); padding: 32px 44px;">
        <q-spinner color="green" size="40px"></q-spinner>
      </div>
    </q-dialog>

    <q-dialog v-model="deleted" persistent>
      <div class="hris-modal">
        <div class="hris-modal-header">
          <h2 class="hris-modal-title">Confirm Deletion</h2>
        </div>
        <div class="hris-modal-body">
          This record will be permanently deleted.
        </div>
        <div class="hris-modal-footer">
          <q-btn flat label="Cancel" class="hris-q-ghost" v-close-popup></q-btn>
          <q-btn unelevated label="Continue" class="hris-q-primary" v-close-popup @click="deletionConfirmation"></q-btn>
        </div>
      </div>
    </q-dialog>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import mixins from '../../mixins';


export default {

	data () {
		return {
			tempID:0,
			spinner:false,
			deleted:false,
			empStatus:null,
			is_active:'Y',
			data:[],
			type:'empStatus',
			columns: [
			{ name: 'id', align: 'center', label: 'ID', field: 'id', sortable: true },
			{ name: 'name', align: 'center', label: 'Name', field: 'name', sortable: true },
			{ name: 'is_active', align: 'center', label: 'Status', field: 'is_active' , sortable: true},
			{ name: 'action', align: 'center', label: 'Action', field: '', sortable: true },
			],
			pagination: {
				rowsPerPage: 20
			},
		}
	},

	created(){
		this.displayData()
	},

	methods: {

		onSubmit : function(){
			this.spinner = true;
			let formData = new FormData();

			formData.append("name", this.empStatus);
			formData.append("type", this.type);
			formData.append("status", this.is_active);
			formData.append("tempID", this.tempID);

			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/admin/setting/relationship',formData)
			.then((res) => {
				this.displayData()
				this.empStatus = ''
				this.is_active = ''
				this.tempID = 0
				this.spinner = false;
				this.$refs.vForm.reset()
			});
		},

		displayData: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/setting/${this.type}`)
			.then((res) => {
				this.data = res.data.data;
				setTimeout(() => {
					this.spinner = false
				},500)
			})

		},

		selectedRow:function(obj){
			this.empStatus = obj.row.name
			this.is_active = obj.row.is_active
			this.tempID = obj.row.id
		},

		removeRow:function(obj){

			this.deleted = true
			this.tempID = obj.row.id
		},

		deletionConfirmation:function(){
			this.spinner = true;
			let formData = new FormData();
			formData.append("tempID", this.tempID);
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/admin/setting/delete',formData)
			.then((res) => {
				this.tempID = 0
				this.displayData()
			});
		}

	}
}
</script>
<style>
.caps {
	text-transform: uppercase
}
</style>